import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { ActivatedRoute, Router } from '@angular/router';
import firebase from 'firebase/app';
import 'firebase/auth';
import { AlertService } from './alert.service';
import { StorageService } from './storage.service';
import { LoaderServiceService } from './loader-service.service';
import { environment } from 'src/environments/environment';
// import Cookies from 'js-cookie';
import * as CryptoJS from 'crypto-js';
import * as Cookies from 'js-cookie';
import { CustomConfirmDialogComponent } from '../shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SM_CONSTANTS } from '../shared/constants/sm-constants';
import { Observable, throwError } from 'rxjs';
import { map, retryWhen, scan, delay, catchError } from 'rxjs/operators';
import { AutoLoginLoaderService } from './auto-login-loader.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _recaptchaVerifier: any;
  private _confirmationResult: any = '';
  private readonly COOKIE_NAME = 'user_role';
  private readonly SECRET_KEY = environment.cookie_hex_key;
  constructor(
    private _fireAuth: AngularFireAuth,
    private _router: Router,
    private dialog: MatDialog,
    private _alertService: AlertService,
    private _storageService: StorageService,
    private loaderservice:LoaderServiceService,
    private alloader:AutoLoginLoaderService,
    private http:HttpClient,
    private route: ActivatedRoute
  ) {}

  initRecaptcha(buttonRef: HTMLButtonElement) {
    this._recaptchaVerifier = new firebase.auth.RecaptchaVerifier(buttonRef, {
      size: 'invisible',
      'expired-callback': () => {
        console.log('captcha expired');
      },
    });
  }

  async onReceiveOTP(phoneNumber: string) {
    try {
      this.loaderservice.showLoader = true
      const result = await this._fireAuth.signInWithPhoneNumber(
        phoneNumber,
        this._recaptchaVerifier
      );
      this.loaderservice.showLoader = false
      console.log(result);
      this._confirmationResult = result;
      return true;
    } catch (error) {
      this.loaderservice.showLoader = false
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
        width:'500px',
        data: {
          title: "System error!",
          message:
            "There is some issue with the phone number you entered. Check the number for once. Or try again.",
          okbtn: 'Ok',
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
      return false;
    }
  }

  async onSignInWithPhone(otp: string) {
    try {
      this.loaderservice.showLoader = true
      const result = await this._confirmationResult.confirm(otp);
      if (result.user) {
        console.log(result.user.uid);
        document.cookie = `fbid=${result.user.uid};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
      }
      this.loaderservice.showLoader = false
      return result;
    } catch (error) {
      this.loaderservice.showLoader = false
      console.error(error);
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
        data: {
          title: 'Alert',
          message:
            'Invalid OTP! Please enter a valid otp.',
          okbtn: 'Ok',
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
      return null;
    }
  }

  async autoLogin() {
    const uid = this.getCookie('fbid'); // Read UID from cookie
    if (!uid) {
      console.error('No UID found in cookies');
      this.alloader.showLoader = false
      return;
    }

    try {
      this.alloader.showLoader = true
      const customToken = await this.getCustomToken(uid).toPromise(); // Use toPromise() instead of firstValueFrom
      if (!customToken) {
        console.error('Custom token is null, auto-login failed');
        this.alloader.showLoader = false
        return;
      }

      const userCredential = await this._fireAuth.signInWithCustomToken(customToken);
      return userCredential.user;
    } catch (error) {
      console.error('Auto-login failed:', error);
      this.alloader.showLoader = false
      throw error; // Allows .then/.catch when calling autoLogin()
    }
  }

  getCookie(name: string): string | null {
    const matches = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  private apiUrl = 'https://us-central1-lookzup-platform.cloudfunctions.net/getCustomAuthToken';

  getCustomToken(uid: string): Observable<string> {
    return this.http.post(this.apiUrl, { uid }, { responseType: 'text' }).pipe(
      map(response => {
        if (!response) {
          throw new Error('Empty response received'); // Force retry if empty
        }
        return response; // Return valid token
      }),
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 5) {
              throw error; // Stop after 5 retries
            }
            console.warn(`Retry ${retryCount + 1}: Retrying getCustomToken...`);
            return retryCount + 1;
          }, 0),
          delay(500) // Wait 1 second before each retry
        )
      ),
      catchError(error => {
        console.error('Final failure after retries:', error);
        return throwError(() => new Error('Failed to fetch custom token after multiple attempts'));
      })
    );
  }

  onSignOut() {
    this._fireAuth
      .signOut()
      .then((_) => {
        this.clearAllCookies()
        this._storageService.clearAppStorage();
        this._storageService.clearLocalStorage();
        this._storageService.clearSessionStorage();
        this.clearUserRole();
        this.loaderservice.showLoader = false
        this.alloader.showLoader = false
        this._router.navigateByUrl('/login').then((_) => {
          this._alertService.onOpenSnackbar('Signed out successfully');
        });
      })
      .catch((error) => console.error(error));
  }
  onSignOutWithoutMessage() {   
    this._fireAuth
      .signOut()
      .then((_) => {
        this.clearAllCookies()
        this._storageService.clearAppStorage();
        this._storageService.clearLocalStorage();
        this._storageService.clearSessionStorage();
        this.clearUserRole();
        this.loaderservice.showLoader = false
        this.alloader.showLoader = false
        console.log('snapshot check if login', this._router.url == '/');
        if(!(this._router.url == '/')){
          this._router.navigate(['/login'],{queryParamsHandling: 'preserve'})

        }
      })
      .catch((error) => console.error(error));
  }
  onSignOutAfterPhoneChange() {
    this._fireAuth
      .signOut()
      .then((_) => {
        this.clearAllCookies()
        this._storageService.clearAppStorage();
        this._storageService.clearLocalStorage();
        this._storageService.clearSessionStorage();
        this.clearUserRole();
        this.loaderservice.showLoader = false
        this.alloader.showLoader = false
        this._router.navigateByUrl('/login').then((_) => {
          this._alertService.onOpenSnackbar('Phone number changed successfully. Please log in again with the new number.', 5000, 'Ok');
        });
      })
      .catch((error) => console.error(error));
  }
  onSignOutWithoutRedirect() {
    this._fireAuth
      .signOut()
      .then((_) => {
        this.clearAllCookies()
        this._storageService.clearAppStorage();
        this._storageService.clearLocalStorage();
        this._storageService.clearSessionStorage();
        this.clearUserRole();
        this.loaderservice.showLoader = false
        this.alloader.showLoader = false
      })
      .catch((error) => console.error(error));
  }
async onSignOutWithoutRedirectAndKeepCookie(): Promise<void> {
  try {

    this.loaderservice.showLoader = true
    // STORE COOKIE BEFORE CLEARING DATA
    const headers = new HttpHeaders({
      'accountHashId': localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      'tokenType': '3'
    });

    const url = `${environment.apiUserServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_DETAIL}`;

    const response:any = await this.http.get(url, { headers }).toPromise();
    console.log('User detail response in auth service to set cookie:', response);
    let accId = localStorage.getItem(
      SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
    );
    let prfId = response.profileHashId;
    let aCountryCode = localStorage.getItem(
      SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE
    );
    let aPhone = localStorage.getItem(
      SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER
    );
    
    document.cookie = `accId=${accId};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
    document.cookie = `prfId=${prfId};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
    document.cookie = `aCountryCode=${aCountryCode};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
    document.cookie = `aPhone=${aPhone};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
    

    // CLEAR DATA after API completes
    await this._fireAuth.signOut();
    this._storageService.clearAppStorage();
    this._storageService.clearLocalStorage();
    this._storageService.clearSessionStorage();
    this.clearUserRole();
    this.loaderservice.showLoader = false;
    this.alloader.showLoader = false;

    console.log('logging after clear in auth', localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID));
  } catch (error) {
    console.error('Sign out or API failed:', error);
    throw error;
  }
}



  async delete() {
    try {
      // Get the current user
      const user = await this._fireAuth.currentUser;
      
      console.log(user);
      user?.delete().then(res => {
       console.log(res);
       
     });
      return true;
    } catch (error:any) {
      console.error(error);
      // Handle errors appropriately
      alert(error.message);
      return false;
    }
  }

  async check() {
    try {
      // Get the current user
      const user = await this._fireAuth.currentUser;
      
      console.log(user);
      return true;
    } catch (error:any) {
      console.error(error);
      // Handle errors appropriately
      alert(error.message);
      return false;
    }
  }
  async changePhoneNumber(otp: string) {
    try {
      this.loaderservice.showLoader = true
      // Get the current user
      const user = await this._fireAuth.currentUser;
      
      console.log(user);
      console.log(this._confirmationResult);
      
      // Create a phone credential with the new phone number and the verification code (OTP)
      const credential = firebase.auth.PhoneAuthProvider.credential(
        this._confirmationResult.verificationId,
        otp
      );
      console.log(credential);
        
      // Reauthenticate the user with the phone credential
      // const res =  await user!.reauthenticateWithCredential(credential);
      // console.log(res);
        
      // Update the phone number
      const result = await user!.updatePhoneNumber(credential);
      this.loaderservice.showLoader = false
      console.log(result);
      
      return result;
    } catch (error) {
      this.loaderservice.showLoader = false
      console.error(error);
      // Handle errors appropriately
      // alert(error.message);
      throw error;
    }
  }
  async getToken(): Promise<string | null> {
    const user = await new Promise<firebase.User | null>((resolve) => {
      const unsubscribe = this._fireAuth.onAuthStateChanged(async (currentUser) => {
        (await unsubscribe)(); // Unsubscribe after receiving the user state
        resolve(currentUser);
      });
    });

    if (user) {
      const token = await user.getIdToken(); // true forces a refresh
      return token;
    }
    return null;
  }

  getRefreshToken(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const attemptToGetToken = () => {
        this._fireAuth.currentUser
          .then(user => {
            if (user) {
              return user.getIdToken(true); // Force a token refresh
            } else {
              throw new Error('User not authenticated');
            }
          })
          .then(token => {
            if (token) {
              resolve(token);
            } else {
              // Retry if the token is not obtained
            setTimeout(attemptToGetToken, 500); // Retry after 1 second (adjust the interval as needed)
            }
          })
          .catch(error => {
            setTimeout(attemptToGetToken, 500); // Retry after 1 second if an error occurs
          });
      };
  
      // Initial attempt to get the token
      attemptToGetToken();
    });
  
  }



  // COOKIE-POLICY FOR USER ROLE

  private generateHMAC(data: string): string {
    return CryptoJS.HmacSHA256(data, this.SECRET_KEY).toString();
  }

  setUserRole(role: 'owner' | 'employee'): void {
    const signature = this.generateHMAC(role);
    const valueWithSignature = `${role}.${signature}`;
    Cookies.set(this.COOKIE_NAME, valueWithSignature, { expires: 1, secure: true, sameSite: 'Strict' });
  }


  getUserRole(): 'owner' | 'employee' | null {
    const storedValue = Cookies.get(this.COOKIE_NAME);
    if (!storedValue) return null;

    const [role, signature] = storedValue.split('.');
    if (!role || !signature) return null; // Invalid format

    const validSignature = this.generateHMAC(role);
    if (signature !== validSignature) {
      console.warn('Tampering detected! Invalid cookie.');
      this.clearUserRole(); // Remove tampered cookie
      return null;
    }

    return role === 'owner' || role === 'employee' ? role as 'owner' | 'employee' : null;
  }


  clearUserRole(): void {
    Cookies.remove(this.COOKIE_NAME);
  }


  isOwner(): boolean {
    return this.getUserRole() === 'owner';
  }

  isEmployee(): boolean {
    return this.getUserRole() === 'employee';
  }

  async resendOTP(phoneNumber: string) {
    try {
      this.loaderservice.showLoader = true;
  
      // Reinitialize the recaptcha verifier if it has expired
      if (!this._recaptchaVerifier) {
        console.log('Reinitializing reCAPTCHA');
        this.initRecaptcha(document.getElementById('resendOtpButton') as HTMLButtonElement);
      }
  
      const result = await this._fireAuth.signInWithPhoneNumber(
        phoneNumber,
        this._recaptchaVerifier
      );
  
      this.loaderservice.showLoader = false;
      console.log('OTP resent successfully', result);
      this._confirmationResult = result;
      return true;
    } catch (error:any) {
      this.loaderservice.showLoader = false;
      console.error('Error resending OTP', error);
      alert(error.message);
      return false;
    }
  }

  
  clearAllCookies() {
    const domains = [window.location.hostname, ".lookzup.com"];

    // Extract all subpaths the user has visited based on the current URL
    const pathname = window.location.pathname; // e.g., "/business/GlamourSalon&Spa"
    const subpaths = pathname.split("/").filter(p => p); // Remove empty entries

    // Generate all possible paths where cookies might exist
    const paths = ["/"];
    let currentPath = "";
    subpaths.forEach(sub => {
      currentPath += `/${sub}`;
      paths.push(currentPath);
    });

    // Loop through all cookies and delete them for each path & domain
    document.cookie.split(";").forEach(cookie => {
      const [name] = cookie.split("=");
      domains.forEach(domain => {
        paths.forEach(path => {
          document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}`;
        });
      });
    });

    console.log("All cookies cleared for paths:", paths);
  }

}
